import React, { ChangeEvent } from 'react'
import ControlInput from 'workflow/common/controlInput'

import { replaceLineBreakAsNewLineEmoji } from 'common/variantsUtils'

import { useTweakVariant } from '../context/TweakVariantContext'

const changeReasonPlaceholder =
  'Explain as best as possible so we can learn and give better results in the future.'

const EditForm = () => {
  const context = useTweakVariant()
  const {
    variantText,
    showTweakingReason,
    noTweakingReason,
    tweakingReason,
    selectedLine,
    updateState,
    feedbackEditEnabled,
    selectedState,
    newlinesInVariants,
  } = context

  const tweakingLine = (value: string, originalValue: string) => {
    const showTweakingReason = selectedLine.text.trim() !== originalValue.trim()

    updateState({
      variantText: value,
      showTweakingReason,
    })
  }

  const tweakingReasonChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    const reason = event.target.value

    updateState({
      tweakingReason: reason,
      noTweakingReason: reason.trim() === '',
    })
  }

  const onBlur = () => {
    updateState({ variantText: replaceLineBreakAsNewLineEmoji(variantText) })
  }

  return feedbackEditEnabled && selectedState === 'edit' ? (
    <div>
      <React.Fragment>
        <div className="mt-6 text-sm mb-1">
          <p className="mb-2 font-normal text-base text-coolGray-800">
            Make your edits here:
          </p>
          <ControlInput
            data-cy="textarea-edited-line"
            data-testid="edited-line-textarea"
            onBlur={onBlur}
            value={variantText}
            onChange={tweakingLine}
            maxRows={newlinesInVariants?.max}
            rows={5}
            className="placeholder-gold-700 bg-white focus:border-gold-400 hover:border-gold-400"
          />
        </div>
        <div className="mt-6">
          <p className="mb-2 font-normal text-base text-coolGray-800">
            Please tell us why
          </p>
          <textarea
            data-cy="textarea-reason-test"
            data-testid="edit-reason-textarea"
            onChange={tweakingReasonChange}
            value={tweakingReason}
            placeholder={changeReasonPlaceholder}
            rows={4}
            className="updated-component w-full border border-gold-400 rounded-sm px-3 py-2 text-sm bg-gold-40 text-base-700 placeholder-gold-700 focus:border-gold-400 hover:border-gold-400 outline-none resize-none"
          />
          {showTweakingReason && noTweakingReason ? (
            <div className="text-red-400">Please give us a reason</div>
          ) : undefined}
        </div>
      </React.Fragment>
    </div>
  ) : null
}

export default EditForm
